import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import { useTranslation, withTranslation } from 'react-i18next';
import { ReferPatientForm } from '../../../components/Protocols/Patients';
import { getReferPatientSchema } from '../../../components/Validations/FormValidationSchema';
import { referPatient } from '../../../api/protocol';
import { ErrorMessage, Success } from '../../../components/Notifications/Notifications';

export const ReferPatientModal = ({ isShowing, hide, submit, patient, protocolId }) => {
    const { t } = useTranslation();

    return isShowing ? ReactDOM.createPortal(
        <React.Fragment>
            <BootstrapModal show={true} onHide={hide} bsSize="large" backdrop="static" >
                <BootstrapModal.Header closeButton>
                    <BootstrapModal.Title>{t('protocols.patient.referPatient')}</BootstrapModal.Title>
                </BootstrapModal.Header>
                <BootstrapModal.Body>
                    <ProtocolReferPatienContainer protocolId={protocolId} patient={patient} onCancel={hide} onSubmit={submit} />
                </BootstrapModal.Body>
            </BootstrapModal>
        </React.Fragment>, document.body
    ) : null;
};

const ProtocolReferPatienContainer = withTranslation()(withFormik({
    mapPropsToValues: (props) => (props.patient),

    validationSchema: getReferPatientSchema(),

    handleSubmit: async (values, formikBag) => {
        try {
            await referPatient(formikBag.props.protocolId, values.numberInProtocol, values)
            formikBag.props.onSubmit(values);
            Success("commons.successSave");
        } catch (error) {
            ErrorMessage("commons.errorSave");
        } finally {
            formikBag.setSubmitting(false);
        }
    },

    displayName: 'ReferPatientForm',

})(ReferPatientForm));

ProtocolReferPatienContainer.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    protocolId: PropTypes.string.isRequired,
};